import React, { useMemo } from 'react'
import { parseISO, format } from 'date-fns'
import { Box, Text, H6 } from '@maui/elements'
import { DetailsTimelineChart, timelineIcons } from '@/components/charts'
import { formatData } from './timelineUtils'

const PointSymbol = (e) => {
  const { datum: { chartDescription } } = e

  const knownType = Object.keys(timelineIcons).includes(chartDescription)

  const circleBaseRadius = 12
  const { d, transform } = timelineIcons[knownType ? chartDescription : 'other']

  return (
    <>
      <Box as="circle" cx="0" cy="0" r={circleBaseRadius} fill='colorBrandingMandiantRed' />
      <Box as="path" d={d} transform={transform} fill='colorActionSecondaryHover' />
    </>
  )
}

const Tooltip = (item) => {
  const { point: { data } } = item
  const date = parseISO(data.xFormatted)
  const formattedDate = format(date, 'MM/dd/yyyy')

  return (
    <Box
      maxWidth='200px'
      width='100%'
      display='flex'
      flexDirection='column'
      justifyContent='center'
      alignItems='center'
      background='colorBrandingMandiantRed'
      color='colorBaseWhite'
      padding='8px 8px 6px 8px'
      zIndex='100000'
      gap='4px'
      borderRadius='4px'
    >
      <H6 m="0" textAlign="center">{ data.description }</H6>
      {
        data.description === 'Exploit Release Date' && data?.name && (
          <Text fontWeight='400' fontSize='12px'>{ data.name }</Text>
        )
      }
      <Text fontWeight='400' fontSize='12px'>{ formattedDate }</Text>
    </Box>
  )
}

export function VulnTimeline({ cisaKnownExploited, disclosureDate, exploits, publishedDate }) {
  const updatedData = useMemo(() => {
    return formatData(cisaKnownExploited, disclosureDate, exploits, publishedDate)
  }, [cisaKnownExploited, disclosureDate, exploits, publishedDate])

  const firstDate = useMemo(() => {
    return parseISO(updatedData[0].data[0].x)
  }, [updatedData])

  const lastDate = useMemo(() => {
    return parseISO(updatedData[0].data[updatedData[0].data.length - 1].x)
  }, [updatedData])

  return (
    <DetailsTimelineChart
      data={updatedData}
      pointSymbol={PointSymbol}
      firstDate={firstDate}
      lastDate={lastDate}
      tooltip={Tooltip}
    />
  )
}

export default React.memo(VulnTimeline)
